import * as Immutable from 'immutable';
import moment from 'moment';
import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { Segment } from 'semantic-ui-react';

import { EventsProps } from '../../reducers/DashboardReducer/EventsReducer/EventsReducer.types';
import { formatMessageHelper } from '../../shared/helpers/internationalization';
import { addModifiers } from '../../shared/helpers';

import Context from './Context';

interface NavProps {
  currentDate: moment.Moment;
  selectDate: (currentDate: moment.Moment) => void;
  data: Immutable.List<EventsProps>;
  handleCloseEventsCards: () => void;
}

const Nav = injectIntl(({ currentDate, selectDate, data, intl, handleCloseEventsCards }: NavProps & InjectedIntlProps) => {
  const goPrev = () => {
    selectDate(moment(currentDate).subtract(1, 'M'));
    handleCloseEventsCards();
  };

  const goNext = () => {
    selectDate(moment(currentDate).add(1, 'M'));
    handleCloseEventsCards();
  };

  return (
    <Segment className="ws-segment">
      <div className="events__navigation">
        <div className="events__navigation-actions">
          <div className="pagination-footer__buttons-container">
            <button className={addModifiers('pagination-footer__button', ['previous', 'active'])} onClick={goPrev}>
              {formatMessageHelper(intl, 'events.prev')}
            </button>
            <button className={addModifiers('pagination-footer__button', ['next', 'active'])} onClick={goNext}>
              {formatMessageHelper(intl, 'events.next')}
            </button>
          </div>
        </div>
        <div className="events__navigation-title">{moment(currentDate).format('MMMM YYYY')}</div>
        <div className="events__navigation-count">
          {' '}
          {data.size} {formatMessageHelper(intl, 'app.events')}
        </div>
      </div>
    </Segment>
  );
});

export const Navigation = () => (
  <Context.Consumer>
    {({ currentDate, selectDate, data, isFetching, handleCloseEventsCards }) =>
      isFetching ? null : (
        <Nav currentDate={currentDate} selectDate={selectDate} data={data} handleCloseEventsCards={handleCloseEventsCards} />
      )
    }
  </Context.Consumer>
);
